import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import Image from "next/image";

import empty from "../../../../../public/assets/images/empty.svg";

const useStyles = makeStyles((theme) => ({
  t1: {
    color: "#0A369D",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 30,
    textAlign: "center",
    marginBottom: 30,
  },
  image: {
    maxWidth: "94%",
    margin: "0 auto",
    width: 463,
    [theme.breakpoints.down("md")]: {
      width: 200,
    },
  },
}));

const Empty = ({ text = "در این بخش اطلاعاتی برای نمایش وجود ندارد." }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      style={{
        maxWidth: "100%",
        backgroundColor: "#fff",
        marginTop: 10,
        paddingTop: 10,
      }}
    >
      <Grid item xs={12}>
        <div className={classes.image}>
          <Image
            src={empty}
            blurDataURL={empty}
            layout="responsive"
            width={463}
            height={349}
            alt="Empty"
            style={{ position: "static", display: "block" }}
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.t1}>
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Empty;
